import { render, staticRenderFns } from "./DCardActionOverlay.vue?vue&type=template&id=5dca155e"
import script from "./DCardActionOverlay.vue?vue&type=script&lang=js"
export * from "./DCardActionOverlay.vue?vue&type=script&lang=js"
import style0 from "./DCardActionOverlay.vue?vue&type=style&index=0&id=5dca155e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../../@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QToolbar,QBtn,QSpinnerDots,QSpace,QMenu,QList,QItem,QItemSection,QIcon});qInstall(component, 'directives', {Ripple});
